<template>
  <section id="pricing" class="pricing">
    <div class="pricing-grid">
      <div v-for="plan in plans" :key="plan.id" 
           :class="['pricing-card', { featured: plan.featured }]">
        <h3>{{ plan.name }}</h3>
        <div class="price">{{ plan.price }}<span>/mo</span></div>
        <ul>
          <li v-for="(feature, index) in plan.features" :key="index">
            {{ feature }}
          </li>
        </ul>
        <button class="pricing-cta">{{ plan.cta }}</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PricingSection',
  data() {
    return {
      plans: [
        {
          id: 1,
          name: 'Starter',
          price: '$99',
          features: [
            '100 leads/month',
            'Basic AI customization',
            'Email verification',
            'Simple CRM integration'
          ],
          cta: 'Get Started'
        },
        {
          id: 2,
          name: 'Professional',
          price: '$249',
          features: [
            '500 leads/month',
            'Advanced AI customization',
            'Full data enrichment',
            'All CRM integrations',
            'FAQ automation'
          ],
          featured: true,
          cta: 'Get Started'
        },
        {
          id: 3,
          name: 'Enterprise',
          price: 'Custom',
          features: [
            'Unlimited leads',
            'Custom AI model',
            'Priority support',
            'Custom integrations',
            'Advanced analytics'
          ],
          cta: 'Contact Us'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* Pricing section styles from previous CSS */
.pricing {
  padding: 4rem 2rem;
  background: white;
}

.pricing-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem 0;
}

.pricing-card {
  padding: 2rem;
  border-radius: var(--border-radius);
  border: 1px solid #e5e7eb;
  text-align: center;
}

.pricing-card.featured {
  border: 2px solid var(--primary-color);
  transform: scale(1.05);
}

.price {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 1rem 0;
}

.price span {
  font-size: 1rem;
  color: #6b7280;
}

.pricing-card ul {
  list-style: none;
  margin: 2rem 0;
}

.pricing-card li {
  margin: 0.5rem 0;
}

.pricing-cta {
  width: 100%;
  padding: 1rem;
  border-radius: var(--border-radius);
  background: var(--primary-color);
  color: white;
  border: none;
  font-weight: 600;
  cursor: pointer;
}
</style> 